export const formatPaymentMethodLabel = (rawMethod) => {
  if (!rawMethod) return null

  const method = String(rawMethod)

  if (method.includes("PAGARE") || method.toLowerCase().includes("pagare")) return "Pagare"
  if (method.includes("Efectivo")) return "Efectivo"
  if (method.includes("Tarjeta")) return "Tarjeta"
  if (method.includes("Transferencia")) return "Transferencia"
  if (method.includes("Por definir")) return "Otros"

  return method
}

export const formatTicketPaymentMethods = (ticket) => {
  const payments = ticket?.ticket_payments
  const paymentList = Array.isArray(payments) ? payments : payments ? [payments] : []
  const methods = paymentList
    .map((payment) => (
      payment?.pay_method_label ||
      payment?.pay_method?.label ||
      payment?.pay_method?.name ||
      payment?.pay_method
    ))
    .map(formatPaymentMethodLabel)
    .filter(Boolean)

  if (methods.length === 0) {
    return "Sin metodo"
  }

  return [...new Set(methods)].join(" / ")
}
